import { MapPin, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/site/Logo";
import { PHONE_DISPLAY, whatsappUrl } from "@/components/site/WhatsAppFloat";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-white"
    >
      <div className="container-wide py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo withTagline variant="dark" className="scale-110 origin-left" />
          <p className="mt-6 max-w-md text-sm leading-relaxed text-muted-foreground">
            L'expertise clé en main pour votre permis de construire à La
            Réunion. Étude de sol et dimensionnement assainissement inclus, en
            partenariat avec Innocean.
          </p>
        </div>

        <div className="md:col-span-2">
          <h5 className="overline mb-4">Navigation</h5>
          <ul className="space-y-2 text-sm text-primary/90">
            <li><a className="underline-link" href="/qui-sommes-nous">À propos</a></li>
            <li><a className="underline-link" href="/#services">Services</a></li>
            <li><a className="underline-link" href="/#pourquoi">Pourquoi nous</a></li>
            <li><a className="underline-link" href="/#process">Process</a></li>
            <li><a className="underline-link" href="/#preuves">Crédibilité</a></li>
            <li><a className="underline-link" href="/#faq">FAQ</a></li>
            <li><Link className="underline-link" to="/ressources">Ressources</Link></li>
            <li><a className="underline-link" href="/#contact">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h5 className="overline mb-4">Contact</h5>
          <ul className="space-y-3 text-sm text-primary/90">
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 text-brand-terra" strokeWidth={1.5} />
              Sur toute l'île de La Réunion
            </li>
            <li className="flex items-start gap-2">
              <Phone size={16} className="mt-0.5 text-brand-terra" strokeWidth={1.5} />
              <a
                href={whatsappUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition-colors"
                data-testid="footer-phone"
                aria-label="Contacter Solmis Habitat sur WhatsApp"
              >
                {PHONE_DISPLAY}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={16} className="mt-0.5 text-brand-terra" strokeWidth={1.5} />
              <a
                href="mailto:contact@solmishabitat.re"
                className="hover:text-primary transition-colors"
              >
                contact@solmishabitat.re
              </a>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-0.5 text-[hsl(var(--brand-terra))]">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </span>
              <a
                href={whatsappUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition-colors"
                data-testid="footer-whatsapp"
              >
                WhatsApp
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h5 className="overline mb-4">Zones d'intervention</h5>
          <ul className="text-sm text-primary/85 leading-relaxed space-y-1.5" data-testid="footer-zones">
            <li><Link className="underline-link" to="/permis-de-construire-saint-denis">Permis de construire Saint-Denis</Link></li>
            <li><Link className="underline-link" to="/permis-de-construire-saint-pierre">Permis de construire Saint-Pierre</Link></li>
            <li><Link className="underline-link" to="/permis-de-construire-le-tampon">Permis de construire Le Tampon</Link></li>
            <li><Link className="underline-link" to="/permis-de-construire-saint-paul">Permis de construire Saint-Paul</Link></li>
            <li><Link className="underline-link" to="/permis-de-construire-sainte-marie">Permis de construire Sainte-Marie</Link></li>
            <li><Link className="underline-link" to="/permis-de-construire-saint-benoit">Permis de construire Saint-Benoît</Link></li>
          </ul>
          <p className="mt-4 text-xs text-muted-foreground leading-relaxed">
            Petite-Île · Saint-Philippe · Saint-Leu · L'Entre-Deux · Cilaos ·
            Salazie — et toutes les autres communes (974).
          </p>
        </div>
      </div>

      <div className="border-t border-border bg-secondary">
        <div className="container-wide flex flex-col md:flex-row items-center justify-between gap-4 py-7 text-xs text-muted-foreground">
          <p className="text-center md:text-left">
            © {new Date().getFullYear()} <span className="text-primary font-semibold">SOLMIS HABITAT</span> —
            Marque exploitée par EM GROUP (SAS) — Tous droits réservés
          </p>
          <nav className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
            <Link
              to="/mentions-legales"
              data-testid="footer-mentions"
              className="hover:text-primary transition-colors"
            >
              Mentions légales
            </Link>
            <span className="text-border">|</span>
            <Link
              to="/politique-confidentialite"
              data-testid="footer-privacy"
              className="hover:text-primary transition-colors"
            >
              Politique de confidentialité
            </Link>
            <span className="text-border">|</span>
            <Link
              to="/cgv"
              data-testid="footer-cgv"
              className="hover:text-primary transition-colors"
            >
              CGV
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
